module.exports = __webpack_public_path__ + "media/images/banners/banner2-08497896757c35648ad66a810e5a0954.jpg";